<script lang="ts">
  import { searchWikipedia } from './search'
  import { get_word_list } from './get_word_list'
  import { fake } from "./fake"
  import type { IPuzzle } from './puzzles'
  import { 
    CompletedPuzzle, save_completed_puzzles, 
    save_revealed_words, save_turn_is_guess 
  } from './state'

  export let puzzle:IPuzzle
  export let revealed_words:string[]
  export let turn_is_guess:boolean
  export let completed_puzzles:CompletedPuzzle[]
  $: word_list_promise = get_page_data(puzzle.name)
  let guess = ''
  let answer_title = ''
  let won = false
  let wrong = false
  $: placeholder = turn_is_guess ? 'Make a Guess' : 'Reveal a Word'
  $: disabled = !turn_is_guess

  async function get_page_data(article:string):Promise<[string, number][]> {
    console.log('loading', article)
    const page = await searchWikipedia(article)
    answer_title = page.title
    return get_word_list(page, answer_title, puzzle)
  }

  function reveal(word:string) {
    revealed_words = [...revealed_words, word]
    save_revealed_words(revealed_words)
    turn_is_guess = true
    save_turn_is_guess(turn_is_guess)
  }
  function check_answer() {
    if (guess.toLowerCase().trim() === answer_title.toLowerCase()) {
      announce_win()
    } else if (puzzle.answers.includes(guess.toLowerCase())) {
      announce_win()
    } else {
      announce_wrong()
    }
  }
  function announce_wrong() {
    wrong = true
    setTimeout(()=>{
      guess = ''
      turn_is_guess = false
      wrong = false
    }, 500)
  }
  function announce_win() {
    won = true
    completed_puzzles.push({
      title: puzzle.name,
      score: revealed_words.length
    })
    save_completed_puzzles(completed_puzzles)
  }

</script>
<form class='guesser' on:submit|preventDefault={check_answer}>
  <input type='text' {placeholder} {disabled} bind:value={guess} class:wrong={wrong}/>
  <p>Words Revealed: {revealed_words.length}</p>
</form>
<div class='cont'>
{#await word_list_promise}
  Loading...
{:then word_list} 
  {#each word_list as [word], index}
  <p>{index+1}</p>
  {#if revealed_words.includes(word)}
    <p>{word}</p>
  {:else}
    <button on:click={()=>{reveal(word)}}>
      Reveal
    </button>
  {/if}
  {/each}
{/await}
</div>

{#if won}
<div class='win'>
  <h1>Congratulations!</h1>
  <p><a href={`https://en.wikipedia.org/wiki/${puzzle.name}`} target='_blank'>{answer_title}</a>
  was the correct answer.</p>
  <p>It took you {revealed_words.length} reveals to get the answer.</p>
  <p><button on:click={()=>{won = false}}>
    Close
  </button></p>
</div>
{/if}